import React from "react";

const ReviewDetailed = () => {
  return (
    <div>
      <p> Aquí va el detalle de mi reseña</p>
    </div>
  );
};

export default ReviewDetailed;
